import { Quote } from "lucide-react";
import { useScrollAnimation } from "@/hooks/use-scroll-animation";
import { useLanguage } from "@/hooks/use-language";
import LazyVimeo from "./LazyVimeo";

const OutsourcingSection = () => {
  const { ref, isVisible } = useScrollAnimation({ threshold: 0.1 });
  const { t } = useLanguage();

  return (
    <section className="py-32 lg:py-44 bg-background relative overflow-hidden">
      <div className="absolute top-0 right-0 w-[400px] h-[400px] bg-gold/5 rounded-full blur-[120px] translate-x-1/2 -translate-y-1/2" />
      <div className="absolute bottom-0 left-0 w-[300px] h-[300px] bg-navy/5 rounded-full blur-[100px] -translate-x-1/2 translate-y-1/2" />
      
      <div className="container mx-auto px-6 lg:px-8 relative z-10">
        <div ref={ref} className={`max-w-6xl mx-auto transition-all duration-700 ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
          <div className="text-center mb-16">
            <span className="inline-block text-gold text-sm font-bold uppercase tracking-widest mb-4">Outsourcing</span>
            <h2 className="text-3xl md:text-4xl lg:text-5xl font-display font-normal text-foreground mb-6">
              {t("Är du intresserad av outsourcing?", "Interested in outsourcing?")}
            </h2>
          </div>

          <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-16 items-center">
            <div className="relative order-2 lg:order-1">
              <Quote className="absolute -top-4 -left-4 w-16 h-16 text-gold/20" />
              <div className="relative z-10">
                <p className="text-lg text-muted-foreground leading-relaxed mb-8">
                  {t(
                    "En positiv aspekt av att ha outsourcinguppdrag är att det gör att vi slussar in nya medarbetare med att jobba med repetitiva arbetsuppgifter – och då går det snabbt att lära sig och ta med sig erfarenheterna till andra kunder som enbart fokuserar på en effektiv implementation.",
                    "A positive aspect of outsourcing assignments is that it helps us onboard new employees by working on repetitive tasks – and then it becomes quick to learn and bring the experience to other customers who focus solely on an efficient implementation."
                  )}
                </p>
                <p className="text-lg text-muted-foreground leading-relaxed mb-8">
                  {t(
                    "Är ni i behov av outsourcing och vill veta mer? Se gärna filmen med Mattias Elfgren VD & Redovisningsspecialist hos oss på Tiego.",
                    "Do you need outsourcing and want to know more? Watch the video with Mattias Elfgren, CEO & Accounting Specialist at Tiego."
                  )}
                </p>
                <div className="flex items-center gap-4 pt-6 border-t border-border">
                  <div className="w-14 h-14 rounded-full bg-gradient-to-br from-gold/30 to-gold/10 flex items-center justify-center text-navy font-display text-xl">ME</div>
                  <div>
                    <p className="text-foreground font-semibold">Mattias Elfgren</p>
                    <p className="text-muted-foreground text-sm">{t("VD & Redovisningsspecialist, Tiego", "CEO & Accounting Specialist, Tiego")}</p>
                  </div>
                </div>
              </div>
            </div>

            <div className="relative group order-1 lg:order-2">
              <div className="aspect-video rounded-2xl border border-border shadow-xl overflow-hidden">
                <LazyVimeo
                  src="https://player.vimeo.com/video/777002210?dnt=1&title=0&byline=0&portrait=0"
                  title={t("Outsourcing med Mattias Elfgren", "Outsourcing with Mattias Elfgren")}
                />
              </div>
              <div className="absolute -bottom-4 -left-4 w-24 h-24 bg-gradient-to-br from-gold/30 to-gold/10 rounded-2xl -z-10" />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default OutsourcingSection;
